export default __webpack_public_path__ + "static/service-test-97e06ced1c3706c4f9f643a47249649e.jpg";